<div>
  <form [formGroup]="directEntityForm">
    <mat-card>
      <mat-card-content>
        <mat-form-field appearance="fill" [ngClass]="{'readonly-wrapper':id.value}">
          <mat-label>Entity Code</mat-label>
          <input matInput formControlName="code" placeholder="Entity Code" autocomplete="off" maxlength="6">
          @if (code.touched && code.invalid && code.hasError('maxlength')) {
            <mat-error>Direct Entity Code Should be of 6 Characters only</mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Entity Name</mat-label>
          <input matInput formControlName="name" placeholder="Entity Name" autocomplete="off" required>
          @if (name.touched && name.invalid && name.hasError('required')) {
            <mat-error>Direct Entity Name is Required</mat-error>
          }
          @if (name.touched && name.hasError('trimError') && name.invalid) {
            <mat-error>Remove Blank spaces from start and end</mat-error>
          }
        </mat-form-field>
      </mat-card-content>
      <app-address [addressConfig]="addressConfig"></app-address>
      <mat-card-actions>
        @if ((!editPermission && this.id.value) || addPermission) {
          <button mat-button color="primary" (click)="onSave()" style="width: 10%;margin-right: 10px;">Save</button>
        }
        <button mat-button color="cancel" (click)="onCancel()" style="width: 10%;">Cancel</button>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
